// Uitgaande (klant) lotcode — deterministisch afgeleid van de productiedatum + instellingen.
// Diepvries: tracecode = THT = productiedatum + THT-maanden (standaard 18), formaat DDMMJJJJ.
// Vers: dagcode = anker-code + aantal werkdagen (weekend telt niet mee) vanaf de ankerdatum.
const pad2 = (n) => String(n).padStart(2, "0");
const parseISO = (d) => { const p = String(d || "").split("-").map(Number); if (p.length !== 3 || !p[0] || !p[1] || !p[2]) return null; return new Date(Date.UTC(p[0], p[1] - 1, p[2])); };
export const fmtNL = (d) => (d ? `${pad2(d.getUTCDate())}-${pad2(d.getUTCMonth() + 1)}-${d.getUTCFullYear()}` : "");
const addMonths = (d, m) => { const nd = new Date(d.getTime()); const day = nd.getUTCDate(); nd.setUTCMonth(nd.getUTCMonth() + m); if (nd.getUTCDate() < day) nd.setUTCDate(0); return nd; };
// Werkdagen (ma–vr) tussen from en to, teken-gevoelig (weekend telt niet).
const werkdagenTussen = (from, to) => {
  if (!from || !to) return 0;
  let a = new Date(from.getTime()), b = new Date(to.getTime());
  const sign = a <= b ? 1 : -1; if (sign < 0) { const t = a; a = b; b = t; }
  let count = 0; const cur = new Date(a.getTime());
  while (cur < b) { cur.setUTCDate(cur.getUTCDate() + 1); const dow = cur.getUTCDay(); if (dow !== 0 && dow !== 6) count++; }
  return sign * count;
};

export function dagcodeVoor(datumISO, cfg) {
  cfg = cfg || {};
  const d = parseISO(datumISO), anchor = parseISO(cfg.versAnchorDatum), base = Number(cfg.versAnchorCode);
  if (!d || !anchor || !Number.isFinite(base)) return "";
  return String(base + werkdagenTussen(anchor, d));
}

export function uitgaandeLot(product, datumISO, cfg) {
  cfg = cfg || {};
  const d = parseISO(datumISO);
  if (!d) return null;
  const vers = Array.isArray(cfg.versProducten) && cfg.versProducten.includes(product);
  if (vers) {
    const anchor = parseISO(cfg.versAnchorDatum);
    const base = Number(cfg.versAnchorCode);
    if (!anchor || !Number.isFinite(base)) return { type: "Vers", productiedatum: fmtNL(d), tracecode: "" };
    return { type: "Vers", productiedatum: fmtNL(d), tracecode: String(base + werkdagenTussen(anchor, d)) };
  }
  const override = cfg.thtPerProduct && cfg.thtPerProduct[product];
  const maanden = (override != null && override !== "" && Number.isFinite(Number(override))) ? Number(override) : Number(cfg.defaultThtMaanden != null && cfg.defaultThtMaanden !== "" ? cfg.defaultThtMaanden : 18);
  const tht = addMonths(d, maanden);
  const code = `${pad2(tht.getUTCDate())}${pad2(tht.getUTCMonth() + 1)}${tht.getUTCFullYear()}`;
  return { type: "Diepvries", productiedatum: fmtNL(d), tht: fmtNL(tht), tracecode: code };
}
